export default [
  {
    name: '首页',
    url: '/',
    key: '/home/home-index',
    code: ''
  },
  {
    name: '机构概况',
    url: '/',
    key: '/home/institutional-overview',
    code: ''
  },
  {
    name: '出国签证',
    url: '/',
    key: '/home/goaboard',
    code: ''
  },
  {
    name: '领事认证',
    url: '/',
    key: '/home/consular-certification',
    code: ''
  },
  {
    name: '翻译服务',
    url: '/',
    key: '/home/translation-service',
    code: ''
  },
  {
    name: '出国服务',
    url: '/',
    key: '/home/service-abroad',
    code: ''
  },
  {
    name: '外企服务',
    url: '/',
    key: '/home/foreign-company-service',
    code: ''
  },
  {
    name: '联系我们',
    url: '/',
    key: '/home/contactUs',
    code: ''
  }
]



// WEBPACK FOOTER //
// ./src/components/index/headMenu.js